<template>
  <div
    v-if="termsWithBackground.length"
    class="grid grid-cols-2 gap-16 pb-28 md:grid-cols-3"
  >
    <ProductFinderFacetTermCollection
      v-for="term in termsWithBackground"
      :key="term.filter"
      v-bind="term"
      v-model="selected"
      :facet-id="facetId"
    />
  </div>
</template>

<script lang="ts" setup>
import { type FacetValueFragment } from '#graphql-operations'
import { falsy } from '~/helpers/type'

const { collections } = await useWatchCollectionData()

defineOptions({
  name: 'ProductFinderFacetCollection',
})

const props = withDefaults(
  defineProps<{
    facetId: string
    facetLabel: string
    terms?: FacetValueFragment[]
  }>(),
  {
    terms: () => [],
  },
)

// All collection terms that have a background image.
const termsWithBackground = computed(() =>
  props.terms
    .map((term) => {
      const { background, label } = getCollectionData(term.filter)
      if (background && label) {
        return {
          ...term,
          background,
          label,
        }
      }
      return null
    })
    .filter(falsy),
)

const selected = defineModel<string[]>({
  default: () => [],
})

const getCollectionData = (id: string) => {
  const collection = collections.value.find((v) => v.id && v.id === id)

  const background = buildWatchCollectionBackground(collection?.backgroundImage)
  const label = collection?.label
  return { background, label }
}
</script>
